export default __webpack_public_path__ + "static/media/Popup_right.b0494952.svg";